import { render, staticRenderFns } from "./DriveGalleryGrid.vue?vue&type=template&id=22b4df78"
import script from "./DriveGalleryGrid.vue?vue&type=script&lang=ts"
export * from "./DriveGalleryGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports